import { render, staticRenderFns } from "./FilterNftCollection.vue?vue&type=template&id=0a87d243&scoped=true"
import script from "./FilterNftCollection.vue?vue&type=script&lang=ts"
export * from "./FilterNftCollection.vue?vue&type=script&lang=ts"
import style0 from "./FilterNftCollection.vue?vue&type=style&index=0&id=0a87d243&prod&lang=scss&scoped=true"
import style1 from "./FilterNftCollection.vue?vue&type=style&index=1&id=0a87d243&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a87d243",
  null
  
)

export default component.exports